import { components, labelModes } from '@/utils'

function renderSearch(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.search,
        label: this.getTranslate('commons.labels.search'),
        afterIcon: 'search',
        labelMode: labelModes.hidden,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.search = event
        }
      }
    }
  )
}

function renderHeader(h) {
  return h(
    'div',
    {
      class: 'faic ff'
    },
    [ renderSearch.call(this, h) ]
  )
}

function renderItem(h, item) {
  if (item) {
    return h(
      'div',
      {
        class: 'tree__row'
      },
      [
        h(
          'div',
          {
            class: 'tree__content'
          },
          [
            h(
              'div',
              {
                class: 'tree__title tree__title--uncut'
              },
              item
            )
          ]
        )
      ]
    )
  }
}

function renderItems(h) {
  if (Array.isArray(this.values)) {
    if (this.values.length) {
      return h(
        'div',
        {
          class: 'tree__level tree__level--1'
        },
        this.values.map(item => {
          return renderItem.call(this, h, item)
        })
      )
    } else {
      return h(
        'div',
        {
          class: 'tree__empty'
        },
        [ h('g-empty') ]
      )
    }
  }
}

function renderBody(h) {
  return h(
    'div',
    {
      class: 'tree'
    },
    [ renderItems.call(this, h) ]
  )
}

function renderContent(h) {
  return h(
    'div',
    {
      class: 'grid grid-cols--1 grid-gap--8'
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h)
    ]
  )
}

export default function(h) {
  return renderContent.call(this, h)
}
